/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_TodayInputs */

const en_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const de_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const es_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const fr_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const nl_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag`)
};

const it_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

const pt_br2_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const pl_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzisiaj`)
};

const hu_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma`)
};

const ro_admin_dashboard_today = /** @type {(inputs: Admin_Dashboard_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Astazi`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Admin_Dashboard_TodayInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_today = /** @type {((inputs?: Admin_Dashboard_TodayInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_TodayInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_today(inputs)
	if (locale === "de") return de_admin_dashboard_today(inputs)
	if (locale === "es") return es_admin_dashboard_today(inputs)
	if (locale === "fr") return fr_admin_dashboard_today(inputs)
	if (locale === "nl") return nl_admin_dashboard_today(inputs)
	if (locale === "it") return it_admin_dashboard_today(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_today(inputs)
	if (locale === "pl") return pl_admin_dashboard_today(inputs)
	if (locale === "hu") return hu_admin_dashboard_today(inputs)
	return ro_admin_dashboard_today(inputs)
});
export { admin_dashboard_today as "admin.dashboard.today" }